import { createFileRoute } from '@tanstack/react-router'

import { Lens } from '@/pages/Lens/Lens'
import { lensSearchSchema } from '@/pages/Lens/lensSearchSchema'

export const Route = createFileRoute('/_app/lens/')({
  component: Lens,
  validateSearch: lensSearchSchema,
})
